<template>
  <div>
      <a-col :lg="11" :md="11" :sm="11">
    <a-date-picker
      :disabledDate="disabledStartDate"
      :showTime="showTime"
      v-model="startValue"
      placeholder="开始时间"
      @openChange="handleStartOpenChange"
    />
     </a-col>
      <a-col :lg="1" :md="1" :sm="1">
    ~
     </a-col>
      <a-col :lg="11" :md="11" :sm="11">
    <a-date-picker
      :disabledDate="disabledEndDate"
      :showTime="showTime"
      placeholder="结束时间"
      v-model="endValue"
      :open="endOpen"
      @openChange="handleEndOpenChange"
    />
     </a-col>

  </div>
</template>
<script>
export default {
  name:"dateSecondFilter",
  props:{
    showTime:{type:Boolean,default:false}
  },
  data () {
    return {
      startValue: null,
      endValue: null,
      endOpen: false,
    }
  },
  watch: {
    startValue(val) {
      this.$emit("dateToSecendValueChange",val,this.endValue)
    },
    endValue(val) {
      this.$emit("dateToSecendValueChange",this.startValue,val)
    }
  },
  methods: {
    disabledStartDate (startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate (endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange (open) {
      this.endOpen = open;
    },
    reset(){
      this.endValue=null;
      this.startValue=null;
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/form/dateToSecondFilter.vue